//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey = "";
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      if (apiKey) {
        (options.headers as any)["authorization"] = apiKey;
      }
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface IAppealApi {

    getWorker(id: number): Promise<EditWorkerDto>;

    saveWorker(id: number, dto: EditWorkerDto): Promise<number>;

    isAdminEditable(id: number): Promise<boolean>;

    downloadReport(id: number | undefined): Promise<FileResponse>;

    isAppealSent(id: number | undefined): Promise<BooleanDto>;

    getSigningUrl(id: number | undefined): Promise<string>;

    downloadDecisionFile(id: number | undefined): Promise<FileResponse>;

    exportAppeals(id: AppealSearchDto): Promise<FileResponse>;

    completedSteps(id: number | undefined): Promise<AppealSteps[]>;

    managerValidateStep(id: number | undefined, step: AppealSteps | undefined): Promise<number>;

    getManager(id: number): Promise<AppealManagerDto>;

    getReason(id: number): Promise<ReasonDto>;

    getFunctions(id: number): Promise<EditAppealFunctionsDto>;

    getArgument(id: number): Promise<AppealArgumentDto>;

    getArgumentFiles(id: number, decisionFiles: boolean | undefined): Promise<FileEntityDto[]>;

    getAppealSubmit(id: number): Promise<AppealSubmitDto>;

    getAppealCompany(id: number): Promise<AppealCompanyDto>;

    baseSearch(sObj: AppealSearchDto): Promise<PaginatedResultsOfAppealGridDto>;

    baseSearchByUserId(sObj: AppealSearchDto): Promise<PaginatedResultsOfAppealGridDto>;

    saveManager(dto: AppealManagerDto): Promise<number>;

    saveReason(dto: ReasonDto): Promise<number>;

    getReasonFile(fileId: number | undefined): Promise<FileResponse>;

    deleteReasonFile(fileId: number | undefined): Promise<void>;

    saveFunctions(dto: EditAppealFunctionsDto): Promise<number>;

    saveArgument(dto: AppealArgumentDto): Promise<number>;

    saveSubmit(dto: AppealSubmitDto): Promise<AppealSubmitSaveResultDto>;

    saveEmployer(dto: AppealCompanyDto): Promise<number>;

    saveArgumentFiles(isDecisionFile: boolean | undefined, id: number | undefined, files: FileParameter[] | null | undefined): Promise<number>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]>;
}

export class AppealApi extends BaseAPI implements IAppealApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getWorker(id: number): Promise<EditWorkerDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/worker";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorker(_response));
        });
    }

    protected processGetWorker(response: Response): Promise<EditWorkerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditWorkerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditWorkerDto>(null as any);
    }

    saveWorker(id: number, dto: EditWorkerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/worker";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveWorker(_response));
        });
    }

    protected processSaveWorker(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isAdminEditable(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/is-admin-editable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsAdminEditable(_response));
        });
    }

    protected processIsAdminEditable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    downloadReport(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Appeal/downloadReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadReport(_response));
        });
    }

    protected processDownloadReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isAppealSent(id: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Appeal/isAppealSent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsAppealSent(_response));
        });
    }

    protected processIsAppealSent(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getSigningUrl(id: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Appeal/getSigningUrl?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSigningUrl(_response));
        });
    }

    protected processGetSigningUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    downloadDecisionFile(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Appeal/downloadDecisionFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadDecisionFile(_response));
        });
    }

    protected processDownloadDecisionFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportAppeals(id: AppealSearchDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Appeal/exportAppeals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportAppeals(_response));
        });
    }

    protected processExportAppeals(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    completedSteps(id: number | undefined): Promise<AppealSteps[]> {
        let url_ = this.baseUrl + "/api/Appeal/completedSteps?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompletedSteps(_response));
        });
    }

    protected processCompletedSteps(response: Response): Promise<AppealSteps[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealSteps[]>(null as any);
    }

    managerValidateStep(id: number | undefined, step: AppealSteps | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/managerValidateStep?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processManagerValidateStep(_response));
        });
    }

    protected processManagerValidateStep(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getManager(id: number): Promise<AppealManagerDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/manager";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetManager(_response));
        });
    }

    protected processGetManager(response: Response): Promise<AppealManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppealManagerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealManagerDto>(null as any);
    }

    getReason(id: number): Promise<ReasonDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/reason";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReason(_response));
        });
    }

    protected processGetReason(response: Response): Promise<ReasonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReasonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReasonDto>(null as any);
    }

    getFunctions(id: number): Promise<EditAppealFunctionsDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/functions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFunctions(_response));
        });
    }

    protected processGetFunctions(response: Response): Promise<EditAppealFunctionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditAppealFunctionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAppealFunctionsDto>(null as any);
    }

    getArgument(id: number): Promise<AppealArgumentDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/argument";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArgument(_response));
        });
    }

    protected processGetArgument(response: Response): Promise<AppealArgumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppealArgumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealArgumentDto>(null as any);
    }

    getArgumentFiles(id: number, decisionFiles: boolean | undefined): Promise<FileEntityDto[]> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/argumentFiles?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (decisionFiles === null)
            throw new Error("The parameter 'decisionFiles' cannot be null.");
        else if (decisionFiles !== undefined)
            url_ += "decisionFiles=" + encodeURIComponent("" + decisionFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArgumentFiles(_response));
        });
    }

    protected processGetArgumentFiles(response: Response): Promise<FileEntityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileEntityDto[]>(null as any);
    }

    getAppealSubmit(id: number): Promise<AppealSubmitDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAppealSubmit(_response));
        });
    }

    protected processGetAppealSubmit(response: Response): Promise<AppealSubmitDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppealSubmitDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealSubmitDto>(null as any);
    }

    getAppealCompany(id: number): Promise<AppealCompanyDto> {
        let url_ = this.baseUrl + "/api/Appeal/{id}/company";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAppealCompany(_response));
        });
    }

    protected processGetAppealCompany(response: Response): Promise<AppealCompanyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppealCompanyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealCompanyDto>(null as any);
    }

    baseSearch(sObj: AppealSearchDto): Promise<PaginatedResultsOfAppealGridDto> {
        let url_ = this.baseUrl + "/api/Appeal/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAppealGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAppealGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAppealGridDto>(null as any);
    }

    baseSearchByUserId(sObj: AppealSearchDto): Promise<PaginatedResultsOfAppealGridDto> {
        let url_ = this.baseUrl + "/api/Appeal/searchByUserId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearchByUserId(_response));
        });
    }

    protected processBaseSearchByUserId(response: Response): Promise<PaginatedResultsOfAppealGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAppealGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAppealGridDto>(null as any);
    }

    saveManager(dto: AppealManagerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/manager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveManager(_response));
        });
    }

    protected processSaveManager(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveReason(dto: ReasonDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveReason(_response));
        });
    }

    protected processSaveReason(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getReasonFile(fileId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Appeal/downloadReasonFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReasonFile(_response));
        });
    }

    protected processGetReasonFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteReasonFile(fileId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Appeal/deleteReasonFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReasonFile(_response));
        });
    }

    protected processDeleteReasonFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveFunctions(dto: EditAppealFunctionsDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/functions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFunctions(_response));
        });
    }

    protected processSaveFunctions(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveArgument(dto: AppealArgumentDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/argument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveArgument(_response));
        });
    }

    protected processSaveArgument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveSubmit(dto: AppealSubmitDto): Promise<AppealSubmitSaveResultDto> {
        let url_ = this.baseUrl + "/api/Appeal/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSubmit(_response));
        });
    }

    protected processSaveSubmit(response: Response): Promise<AppealSubmitSaveResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppealSubmitSaveResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppealSubmitSaveResultDto>(null as any);
    }

    saveEmployer(dto: AppealCompanyDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveEmployer(_response));
        });
    }

    protected processSaveEmployer(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveArgumentFiles(isDecisionFile: boolean | undefined, id: number | undefined, files: FileParameter[] | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Appeal/argumentFiles?";
        if (isDecisionFile === null)
            throw new Error("The parameter 'isDecisionFile' cannot be null.");
        else if (isDecisionFile !== undefined)
            url_ += "isDecisionFile=" + encodeURIComponent("" + isDecisionFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveArgumentFiles(_response));
        });
    }

    protected processSaveArgumentFiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Appeal/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Appeal/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAuthenticateApi {

    login(loginDto: LoginDto): Promise<UserProfileDto>;

    logout(): Promise<FileResponse>;

    lostPassword(email: string | null | undefined): Promise<boolean>;

    signUp(user: EditUserDto): Promise<number>;

    getManagerSignup(userId: number | undefined, token: string | null | undefined): Promise<EditUserDto>;

    profile(): Promise<UserProfileDto>;
}

export class AuthenticateApi extends BaseAPI implements IAuthenticateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    login(loginDto: LoginDto): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        });
    }

    protected processLogin(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    logout(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    lostPassword(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authenticate/lostPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLostPassword(_response));
        });
    }

    protected processLostPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    signUp(user: EditUserDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Authenticate/signUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignUp(_response));
        });
    }

    protected processSignUp(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getManagerSignup(userId: number | undefined, token: string | null | undefined): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/Authenticate/getManagerSignup?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetManagerSignup(_response));
        });
    }

    protected processGetManagerSignup(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    profile(): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/Authenticate/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }
}

export interface IConnectiveCallbackApi {

    post(result: ConnectiveCallbackDto): Promise<FileResponse>;
}

export class ConnectiveCallbackApi extends BaseAPI implements IConnectiveCallbackApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    post(result: ConnectiveCallbackDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ConnectiveCallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDocumentApi {

    signDocument(packageDoc: DocumentRequestDto): Promise<ConnectiveResultDto>;
}

export class DocumentApi extends BaseAPI implements IDocumentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    signDocument(packageDoc: DocumentRequestDto): Promise<ConnectiveResultDto> {
        let url_ = this.baseUrl + "/api/Document/sign-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(packageDoc);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignDocument(_response));
        });
    }

    protected processSignDocument(response: Response): Promise<ConnectiveResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectiveResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectiveResultDto>(null as any);
    }
}

export interface ILanguageApi {

    getLanguages(): Promise<LanguageDto[]>;
}

export class LanguageApi extends BaseAPI implements ILanguageApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLanguages(): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }
}

export interface IMailTemplateApi {

    baseSearch(sObj: MailTemplateSearchDto): Promise<PaginatedResultsOfMailTemplateGridDto>;

    getMailTemplate(id: number): Promise<EditMailTemplateDto>;

    deleteMailTemplate(id: number): Promise<FileResponse>;

    saveMailTemplate(dto: EditMailTemplateDto): Promise<number>;

    getDisplayName(id: number): Promise<DisplayNameDto>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]>;
}

export class MailTemplateApi extends BaseAPI implements IMailTemplateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: MailTemplateSearchDto): Promise<PaginatedResultsOfMailTemplateGridDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMailTemplateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMailTemplateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMailTemplateGridDto>(null as any);
    }

    getMailTemplate(id: number): Promise<EditMailTemplateDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplate(_response));
        });
    }

    protected processGetMailTemplate(response: Response): Promise<EditMailTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMailTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMailTemplateDto>(null as any);
    }

    deleteMailTemplate(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMailTemplate(_response));
        });
    }

    protected processDeleteMailTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveMailTemplate(dto: EditMailTemplateDto): Promise<number> {
        let url_ = this.baseUrl + "/api/MailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMailTemplate(_response));
        });
    }

    protected processSaveMailTemplate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MailTemplate/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/MailTemplate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IMailTemplateTypeApi {

    getDisplayName(id: number): Promise<DisplayNameDto>;

    getMailTemplateTypes(): Promise<MailTemplateTypeGridDto[]>;

    getMailTemplateType(mailTemplateTypeId: number | undefined): Promise<EditMailTemplateTypeDto>;

    saveMailTemplateType(dto: EditMailTemplateTypeDto): Promise<number>;
}

export class MailTemplateTypeApi extends BaseAPI implements IMailTemplateTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDisplayName(id: number): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/MailTemplateType/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getMailTemplateTypes(): Promise<MailTemplateTypeGridDto[]> {
        let url_ = this.baseUrl + "/api/MailTemplateType/getMailTemplateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplateTypes(_response));
        });
    }

    protected processGetMailTemplateTypes(response: Response): Promise<MailTemplateTypeGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailTemplateTypeGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailTemplateTypeGridDto[]>(null as any);
    }

    getMailTemplateType(mailTemplateTypeId: number | undefined): Promise<EditMailTemplateTypeDto> {
        let url_ = this.baseUrl + "/api/MailTemplateType/getMailTemplateType?";
        if (mailTemplateTypeId === null)
            throw new Error("The parameter 'mailTemplateTypeId' cannot be null.");
        else if (mailTemplateTypeId !== undefined)
            url_ += "mailTemplateTypeId=" + encodeURIComponent("" + mailTemplateTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplateType(_response));
        });
    }

    protected processGetMailTemplateType(response: Response): Promise<EditMailTemplateTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMailTemplateTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMailTemplateTypeDto>(null as any);
    }

    saveMailTemplateType(dto: EditMailTemplateTypeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/MailTemplateType/saveMailTemplateType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMailTemplateType(_response));
        });
    }

    protected processSaveMailTemplateType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IReferentialApi {

    languages(): Promise<ReferentialItemDto[]>;

    appealLanguageCodes(): Promise<ReferentialItemDto[]>;

    roles(): Promise<ReferentialItemDto[]>;

    getSectorTypes(): Promise<ReferentialItemDto[]>;

    countries(): Promise<ReferentialItemDto[]>;

    postalCodes(): Promise<PostalCodeReferentialItemDto[]>;

    localities(postalCode: number | undefined): Promise<ReferentialItemDto[]>;

    mailTemplateTypes(): Promise<ReferentialItemDto[]>;

    reasons(): Promise<ReferentialItemDto[]>;

    functions(selectedFunctionIds?: number[]): Promise<FunctionReferentialItemDto[]>;

    categories(): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    languages(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLanguages(_response));
        });
    }

    protected processLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    appealLanguageCodes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/appealLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAppealLanguageCodes(_response));
        });
    }

    protected processAppealLanguageCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    roles(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSectorTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSectorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSectorTypes(_response));
        });
    }

    protected processGetSectorTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    countries(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    postalCodes(): Promise<PostalCodeReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/postalCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostalCodes(_response));
        });
    }

    protected processPostalCodes(response: Response): Promise<PostalCodeReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostalCodeReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostalCodeReferentialItemDto[]>(null as any);
    }

    localities(postalCode: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/localities?";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLocalities(_response));
        });
    }

    protected processLocalities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    mailTemplateTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/mailTemplateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMailTemplateTypes(_response));
        });
    }

    protected processMailTemplateTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    reasons(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/reason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReasons(_response));
        });
    }

    protected processReasons(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    functions(selectedFunctionIds?: number[]): Promise<FunctionReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/functions?";
        if (selectedFunctionIds !== undefined && selectedFunctionIds !== null)
            selectedFunctionIds.forEach(item => { url_ += "selectedFunctionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFunctions(_response));
        });
    }

    protected processFunctions(response: Response): Promise<FunctionReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FunctionReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FunctionReferentialItemDto[]>(null as any);
    }

    categories(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCategories(_response));
        });
    }

    protected processCategories(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISystemApi {

    get(): Promise<SystemInfoDto>;

    getExposedTypes(): Promise<ExposedTypes>;

    geFrontendSettings(): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    geFrontendSettings(): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/fe-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeFrontendSettings(_response));
        });
    }

    protected processGeFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface ITranslationApi {

    getTranslations(languageCode: string | null | undefined): Promise<TranslationDto[]>;

    saveTranslation(languageCode: string | null, dto: SaveTranslationDto): Promise<void>;

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand): Promise<FileResponse>;

    baseSearch(sObj: TranslationSearch): Promise<PaginatedResultsOfTranslationDto>;

    export(): Promise<FileResponse>;

    deleteTranslationCode(translationCode: string | null | undefined): Promise<boolean>;

    upload(file: FileParameter | null | undefined): Promise<Result>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]>;
}

export class TranslationApi extends BaseAPI implements ITranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTranslations(languageCode: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslations(_response));
        });
    }

    protected processGetTranslations(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    saveTranslation(languageCode: string | null, dto: SaveTranslationDto): Promise<void> {
        let url_ = this.baseUrl + "/api/Translation/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTranslation(_response));
        });
    }

    protected processSaveTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(sObj: TranslationSearch): Promise<PaginatedResultsOfTranslationDto> {
        let url_ = this.baseUrl + "/api/Translation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationDto>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTranslationCode(translationCode: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Translation/DeleteCode?";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTranslationCode(_response));
        });
    }

    protected processDeleteTranslationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Translation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Translation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Translation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserApi {

    baseSearch(sObj: UserSearchDto): Promise<PaginatedResultsOfUserGridDto>;

    getUser(id: number): Promise<EditUserDto>;

    deleteUser(id: number): Promise<FileResponse>;

    resetPassword(password: string | null | undefined): Promise<boolean>;

    saveUser(dto: EditUserDto): Promise<number>;

    toggleUserActiveCommand(userId: number | undefined): Promise<number>;

    getDisplayName(id: number): Promise<string>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: UserSearchDto): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getUser(id: number): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    deleteUser(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    resetPassword(password: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/resetPassword?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    saveUser(dto: EditUserDto): Promise<number> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUser(_response));
        });
    }

    protected processSaveUser(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    toggleUserActiveCommand(userId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/User/ToggleUserActiveCommand?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processToggleUserActiveCommand(_response));
        });
    }

    protected processToggleUserActiveCommand(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/User/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/User/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/User/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export class EditWorkerDto implements IEditWorkerDto {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    function?: string | undefined;
    department?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    isAdminAppeal?: boolean;
    address?: AddressDto | undefined;
    language?: AppealLanguageDto | undefined;

    constructor(data?: IEditWorkerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.function = _data["function"];
            this.department = _data["department"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.isAdminAppeal = _data["isAdminAppeal"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.language = _data["language"] ? AppealLanguageDto.fromJS(_data["language"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditWorkerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["function"] = this.function;
        data["department"] = this.department;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["isAdminAppeal"] = this.isAdminAppeal;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditWorkerDto {
        const json = this.toJSON();
        let result = new EditWorkerDto();
        result.init(json);
        return result;
    }
}

export interface IEditWorkerDto {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    function?: string | undefined;
    department?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    isAdminAppeal?: boolean;
    address?: AddressDto | undefined;
    language?: AppealLanguageDto | undefined;
}

export class AddressDto implements IAddressDto {
    id?: number | undefined;
    street?: string | undefined;
    number?: string | undefined;
    postalBox?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalBox = _data["postalBox"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalBox"] = this.postalBox;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id?: number | undefined;
    street?: string | undefined;
    number?: string | undefined;
    postalBox?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
}

export class AppealLanguageDto implements IAppealLanguageDto {
    id?: number;
    code?: AppealLanguageCode;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IAppealLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppealLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        return data;
    }

    clone(): AppealLanguageDto {
        const json = this.toJSON();
        let result = new AppealLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IAppealLanguageDto {
    id?: number;
    code?: AppealLanguageCode;
    dataTranslation?: DataTranslationDto | undefined;
}

export enum AppealLanguageCode {
    Dutch = "Dutch",
    French = "French",
}

export class EntityDto implements IEntityDto {
    id?: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id?: number;
}

export class DataTranslationDto extends EntityDto implements IDataTranslationDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;

    constructor(data?: IDataTranslationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(DataTranslationValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationDto {
        const json = this.toJSON();
        let result = new DataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationDto extends IEntityDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;
}

export class DataTranslationValueDto extends EntityDto implements IDataTranslationValueDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: IDataTranslationValueDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): DataTranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationValueDto {
        const json = this.toJSON();
        let result = new DataTranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationValueDto extends IEntityDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class BooleanDto implements IBooleanDto {
    value?: boolean;

    constructor(data?: IBooleanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }

    clone(): BooleanDto {
        const json = this.toJSON();
        let result = new BooleanDto();
        result.init(json);
        return result;
    }
}

export interface IBooleanDto {
    value?: boolean;
}

export class FilterSearch implements IFilterSearch {
    filter?: string | undefined;

    constructor(data?: IFilterSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): FilterSearch {
        const json = this.toJSON();
        let result = new FilterSearch();
        result.init(json);
        return result;
    }
}

export interface IFilterSearch {
    filter?: string | undefined;
}

export class PaginatedSearch extends FilterSearch implements IPaginatedSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: MaybeOfObject;

    constructor(data?: IPaginatedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.forceSkip = _data["forceSkip"];
            this.forceTake = _data["forceTake"];
            this.parameters = _data["parameters"] ? MaybeOfObject.fromJS(_data["parameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["forceSkip"] = this.forceSkip;
        data["forceTake"] = this.forceTake;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearch {
        const json = this.toJSON();
        let result = new PaginatedSearch();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearch extends IFilterSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: MaybeOfObject;
}

export class AppealSearchDto extends PaginatedSearch implements IAppealSearchDto {
    workerFirstName?: TextSearch | undefined;
    sharepointId?: TextSearch | undefined;
    workerLastName?: TextSearch | undefined;
    employerName?: TextSearch | undefined;
    employerOnssCode?: TextSearch | undefined;
    reason?: TextSearch | undefined;
    createdOn?: DateTimeOffsetSearch | undefined;
    statusId?: ListSearchOfLong | undefined;
    region?: ListSearchOfNullableERegion | undefined;
    isAdminAppeal?: BooleanSearch | undefined;

    constructor(data?: IAppealSearchDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workerFirstName = _data["workerFirstName"] ? TextSearch.fromJS(_data["workerFirstName"]) : <any>undefined;
            this.sharepointId = _data["sharepointId"] ? TextSearch.fromJS(_data["sharepointId"]) : <any>undefined;
            this.workerLastName = _data["workerLastName"] ? TextSearch.fromJS(_data["workerLastName"]) : <any>undefined;
            this.employerName = _data["employerName"] ? TextSearch.fromJS(_data["employerName"]) : <any>undefined;
            this.employerOnssCode = _data["employerOnssCode"] ? TextSearch.fromJS(_data["employerOnssCode"]) : <any>undefined;
            this.reason = _data["reason"] ? TextSearch.fromJS(_data["reason"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? DateTimeOffsetSearch.fromJS(_data["createdOn"]) : <any>undefined;
            this.statusId = _data["statusId"] ? ListSearchOfLong.fromJS(_data["statusId"]) : <any>undefined;
            this.region = _data["region"] ? ListSearchOfNullableERegion.fromJS(_data["region"]) : <any>undefined;
            this.isAdminAppeal = _data["isAdminAppeal"] ? BooleanSearch.fromJS(_data["isAdminAppeal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppealSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workerFirstName"] = this.workerFirstName ? this.workerFirstName.toJSON() : <any>undefined;
        data["sharepointId"] = this.sharepointId ? this.sharepointId.toJSON() : <any>undefined;
        data["workerLastName"] = this.workerLastName ? this.workerLastName.toJSON() : <any>undefined;
        data["employerName"] = this.employerName ? this.employerName.toJSON() : <any>undefined;
        data["employerOnssCode"] = this.employerOnssCode ? this.employerOnssCode.toJSON() : <any>undefined;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toJSON() : <any>undefined;
        data["statusId"] = this.statusId ? this.statusId.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["isAdminAppeal"] = this.isAdminAppeal ? this.isAdminAppeal.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): AppealSearchDto {
        const json = this.toJSON();
        let result = new AppealSearchDto();
        result.init(json);
        return result;
    }
}

export interface IAppealSearchDto extends IPaginatedSearch {
    workerFirstName?: TextSearch | undefined;
    sharepointId?: TextSearch | undefined;
    workerLastName?: TextSearch | undefined;
    employerName?: TextSearch | undefined;
    employerOnssCode?: TextSearch | undefined;
    reason?: TextSearch | undefined;
    createdOn?: DateTimeOffsetSearch | undefined;
    statusId?: ListSearchOfLong | undefined;
    region?: ListSearchOfNullableERegion | undefined;
    isAdminAppeal?: BooleanSearch | undefined;
}

export abstract class FilterCriteriaBaseOfETextSearchTypeAndString implements IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfETextSearchTypeAndString.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfETextSearchTypeAndString {
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class TextSearch extends FilterCriteriaBaseOfETextSearchTypeAndString implements ITextSearch {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: ITextSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): TextSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TextSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): TextSearch {
        const json = this.toJSON();
        let result = new TextSearch();
        result.init(json);
        return result;
    }
}

export interface ITextSearch extends IFilterCriteriaBaseOfETextSearchTypeAndString {
    typeOfCriteria?: ECriteriaType;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export class CombinableCriteriaOfETextSearchTypeAndString implements ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;

    constructor(data?: ICombinableCriteriaOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfETextSearchTypeAndString {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
}

export enum ETextSearchType {
    StartWith = "StartWith",
    EndWith = "EndWith",
    Contains = "Contains",
    NotContains = "NotContains",
    Equals = "Equals",
}

export abstract class FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset implements IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset {
    criterias?: CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.secondaryValue = _data["secondaryValue"] ? new Date(_data["secondaryValue"].toString()) : <any>undefined;
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["secondaryValue"] = this.secondaryValue ? this.secondaryValue.toISOString() : <any>undefined;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset {
        throw new Error("The abstract class 'FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset {
    criterias?: CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class DateTimeOffsetSearch extends FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset implements IDateTimeOffsetSearch {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: IDateTimeOffsetSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): DateTimeOffsetSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeOffsetSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeOffsetSearch {
        const json = this.toJSON();
        let result = new DateTimeOffsetSearch();
        result.init(json);
        return result;
    }
}

export interface IDateTimeOffsetSearch extends IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTimeOffset {
    typeOfCriteria?: ECriteriaType;
}

export class CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset implements ICombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset {
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;

    constructor(data?: ICombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.secondaryValue = _data["secondaryValue"] ? new Date(_data["secondaryValue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["secondaryValue"] = this.secondaryValue ? this.secondaryValue.toISOString() : <any>undefined;
        return data;
    }

    clone(): CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfEDateSearchTypeAndNullableDateTimeOffset {
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
}

export enum EDateSearchType {
    Between = "Between",
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndLong implements IFilterCriteriaBaseOfEListSearchTypeAndLong {
    criterias?: CombinableCriteriaOfEListSearchTypeAndLong[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndLong.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndLong {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndLong' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfEListSearchTypeAndLong {
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndLong' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndLong {
    criterias?: CombinableCriteriaOfEListSearchTypeAndLong[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class ListSearchOfLong extends FilterCriteriaBaseOfEListSearchTypeAndLong implements IListSearchOfLong {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: IListSearchOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): ListSearchOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): ListSearchOfLong {
        const json = this.toJSON();
        let result = new ListSearchOfLong();
        result.init(json);
        return result;
    }
}

export interface IListSearchOfLong extends IFilterCriteriaBaseOfEListSearchTypeAndLong {
    typeOfCriteria?: ECriteriaType;
}

export class CombinableCriteriaOfEListSearchTypeAndLong implements ICombinableCriteriaOfEListSearchTypeAndLong {
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndLong {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfEListSearchTypeAndLong {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfEListSearchTypeAndLong();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndLong {
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
}

export enum EListSearchType {
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableERegion implements IFilterCriteriaBaseOfEListSearchTypeAndNullableERegion {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableERegion[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: ERegion | undefined;
    secondaryValue?: ERegion | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableERegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableERegion.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableERegion {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableERegion' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfEListSearchTypeAndNullableERegion {
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableERegion' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableERegion {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableERegion[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: ERegion | undefined;
    secondaryValue?: ERegion | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class ListSearchOfNullableERegion extends FilterCriteriaBaseOfEListSearchTypeAndNullableERegion implements IListSearchOfNullableERegion {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: IListSearchOfNullableERegion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): ListSearchOfNullableERegion {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableERegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): ListSearchOfNullableERegion {
        const json = this.toJSON();
        let result = new ListSearchOfNullableERegion();
        result.init(json);
        return result;
    }
}

export interface IListSearchOfNullableERegion extends IFilterCriteriaBaseOfEListSearchTypeAndNullableERegion {
    typeOfCriteria?: ECriteriaType;
}

export class CombinableCriteriaOfEListSearchTypeAndNullableERegion implements ICombinableCriteriaOfEListSearchTypeAndNullableERegion {
    searchMode?: EListSearchType;
    value?: ERegion | undefined;
    secondaryValue?: ERegion | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableERegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableERegion {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableERegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfEListSearchTypeAndNullableERegion {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableERegion();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableERegion {
    searchMode?: EListSearchType;
    value?: ERegion | undefined;
    secondaryValue?: ERegion | undefined;
}

export enum ERegion {
    Wallonia = "Wallonia",
    Flanders = "Flanders",
    Brussels = "Brussels",
}

export abstract class FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean implements IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
    criterias?: CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
        throw new Error("The abstract class 'FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
    criterias?: CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class BooleanSearch extends FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean implements IBooleanSearch {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: IBooleanSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): BooleanSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): BooleanSearch {
        const json = this.toJSON();
        let result = new BooleanSearch();
        result.init(json);
        return result;
    }
}

export interface IBooleanSearch extends IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
    typeOfCriteria?: ECriteriaType;
}

export class CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean implements ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;

    constructor(data?: ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
}

export enum EBooleanSearchTypes {
    Equals = "Equals",
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }

    clone(): AggregateKeyInfo {
        const json = this.toJSON();
        let result = new AggregateKeyInfo();
        result.init(json);
        return result;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class MaybeOfObject implements IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;

    constructor(data?: IMaybeOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
            this.hasNoValue = _data["hasNoValue"];
        }
    }

    static fromJS(data: any): MaybeOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new MaybeOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        data["hasNoValue"] = this.hasNoValue;
        return data;
    }

    clone(): MaybeOfObject {
        const json = this.toJSON();
        let result = new MaybeOfObject();
        result.init(json);
        return result;
    }
}

export interface IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;
}

export enum AppealSteps {
    Worker = "Worker",
    Employer = "Employer",
    Contact = "Contact",
    Reason = "Reason",
    Function = "Function",
    Argument = "Argument",
    Confirm = "Confirm",
}

export class AppealManagerDto implements IAppealManagerDto {
    id?: number;
    appealId?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    function?: string | undefined;
    useAddress?: boolean;
    creationGuid?: string | undefined;
    phone?: string | undefined;
    cellular?: string | undefined;
    email?: string | undefined;
    address?: AddressDto | undefined;
    userId?: number | undefined;

    constructor(data?: IAppealManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appealId = _data["appealId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.function = _data["function"];
            this.useAddress = _data["useAddress"];
            this.creationGuid = _data["creationGuid"];
            this.phone = _data["phone"];
            this.cellular = _data["cellular"];
            this.email = _data["email"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AppealManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appealId"] = this.appealId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["function"] = this.function;
        data["useAddress"] = this.useAddress;
        data["creationGuid"] = this.creationGuid;
        data["phone"] = this.phone;
        data["cellular"] = this.cellular;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AppealManagerDto {
        const json = this.toJSON();
        let result = new AppealManagerDto();
        result.init(json);
        return result;
    }
}

export interface IAppealManagerDto {
    id?: number;
    appealId?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    function?: string | undefined;
    useAddress?: boolean;
    creationGuid?: string | undefined;
    phone?: string | undefined;
    cellular?: string | undefined;
    email?: string | undefined;
    address?: AddressDto | undefined;
    userId?: number | undefined;
}

export class ReasonDto implements IReasonDto {
    id?: number | undefined;
    appealId?: number;

    constructor(data?: IReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appealId = _data["appealId"];
        }
    }

    static fromJS(data: any): ReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appealId"] = this.appealId;
        return data;
    }

    clone(): ReasonDto {
        const json = this.toJSON();
        let result = new ReasonDto();
        result.init(json);
        return result;
    }
}

export interface IReasonDto {
    id?: number | undefined;
    appealId?: number;
}

export class EditAppealFunctionsDto implements IEditAppealFunctionsDto {
    id?: number;
    initialFunctions?: AppealFunctionDto[] | undefined;
    finalFunctions?: AppealFunctionDto[] | undefined;
    alternativeFunctions?: AppealFunctionDto[] | undefined;

    constructor(data?: IEditAppealFunctionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["initialFunctions"])) {
                this.initialFunctions = [] as any;
                for (let item of _data["initialFunctions"])
                    this.initialFunctions!.push(AppealFunctionDto.fromJS(item));
            }
            if (Array.isArray(_data["finalFunctions"])) {
                this.finalFunctions = [] as any;
                for (let item of _data["finalFunctions"])
                    this.finalFunctions!.push(AppealFunctionDto.fromJS(item));
            }
            if (Array.isArray(_data["alternativeFunctions"])) {
                this.alternativeFunctions = [] as any;
                for (let item of _data["alternativeFunctions"])
                    this.alternativeFunctions!.push(AppealFunctionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditAppealFunctionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppealFunctionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.initialFunctions)) {
            data["initialFunctions"] = [];
            for (let item of this.initialFunctions)
                data["initialFunctions"].push(item.toJSON());
        }
        if (Array.isArray(this.finalFunctions)) {
            data["finalFunctions"] = [];
            for (let item of this.finalFunctions)
                data["finalFunctions"].push(item.toJSON());
        }
        if (Array.isArray(this.alternativeFunctions)) {
            data["alternativeFunctions"] = [];
            for (let item of this.alternativeFunctions)
                data["alternativeFunctions"].push(item.toJSON());
        }
        return data;
    }

    clone(): EditAppealFunctionsDto {
        const json = this.toJSON();
        let result = new EditAppealFunctionsDto();
        result.init(json);
        return result;
    }
}

export interface IEditAppealFunctionsDto {
    id?: number;
    initialFunctions?: AppealFunctionDto[] | undefined;
    finalFunctions?: AppealFunctionDto[] | undefined;
    alternativeFunctions?: AppealFunctionDto[] | undefined;
}

export class AppealFunctionDto implements IAppealFunctionDto {
    id?: number;
    functionId?: number | undefined;
    attributionPercentage?: number;
    type?: AttributionType;
    functionName?: string | undefined;
    customFunctionName?: string | undefined;
    computedFunctionName?: string | undefined;
    functionCode?: string | undefined;
    categoryName?: string | undefined;
    categoryId?: number | undefined;
    functionCategoryId?: number | undefined;

    constructor(data?: IAppealFunctionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionId = _data["functionId"];
            this.attributionPercentage = _data["attributionPercentage"];
            this.type = _data["type"];
            this.functionName = _data["functionName"];
            this.customFunctionName = _data["customFunctionName"];
            this.computedFunctionName = _data["computedFunctionName"];
            this.functionCode = _data["functionCode"];
            this.categoryName = _data["categoryName"];
            this.categoryId = _data["categoryId"];
            this.functionCategoryId = _data["functionCategoryId"];
        }
    }

    static fromJS(data: any): AppealFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealFunctionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionId"] = this.functionId;
        data["attributionPercentage"] = this.attributionPercentage;
        data["type"] = this.type;
        data["functionName"] = this.functionName;
        data["customFunctionName"] = this.customFunctionName;
        data["computedFunctionName"] = this.computedFunctionName;
        data["functionCode"] = this.functionCode;
        data["categoryName"] = this.categoryName;
        data["categoryId"] = this.categoryId;
        data["functionCategoryId"] = this.functionCategoryId;
        return data;
    }

    clone(): AppealFunctionDto {
        const json = this.toJSON();
        let result = new AppealFunctionDto();
        result.init(json);
        return result;
    }
}

export interface IAppealFunctionDto {
    id?: number;
    functionId?: number | undefined;
    attributionPercentage?: number;
    type?: AttributionType;
    functionName?: string | undefined;
    customFunctionName?: string | undefined;
    computedFunctionName?: string | undefined;
    functionCode?: string | undefined;
    categoryName?: string | undefined;
    categoryId?: number | undefined;
    functionCategoryId?: number | undefined;
}

export enum AttributionType {
    Initial = "Initial",
    Final = "Final",
    Alternative = "Alternative",
}

export class AppealArgumentDto implements IAppealArgumentDto {
    id?: number;
    argumentation?: string | undefined;
    appealReason?: number;
    files?: FileEntityDto[] | undefined;

    constructor(data?: IAppealArgumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.argumentation = _data["argumentation"];
            this.appealReason = _data["appealReason"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppealArgumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealArgumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["argumentation"] = this.argumentation;
        data["appealReason"] = this.appealReason;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }

    clone(): AppealArgumentDto {
        const json = this.toJSON();
        let result = new AppealArgumentDto();
        result.init(json);
        return result;
    }
}

export interface IAppealArgumentDto {
    id?: number;
    argumentation?: string | undefined;
    appealReason?: number;
    files?: FileEntityDto[] | undefined;
}

export class FileEntityDto implements IFileEntityDto {
    id?: number;
    filename?: string | undefined;

    constructor(data?: IFileEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): FileEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filename"] = this.filename;
        return data;
    }

    clone(): FileEntityDto {
        const json = this.toJSON();
        let result = new FileEntityDto();
        result.init(json);
        return result;
    }
}

export interface IFileEntityDto {
    id?: number;
    filename?: string | undefined;
}

export class AppealSubmitDto implements IAppealSubmitDto {
    id?: number;
    communicationDate?: Date;
    decisionDate?: Date;
    appealDoc?: DocumentDto | undefined;
    conformToReality?: boolean;
    reportFileId?: number;
    status?: AppealStatusCode;
    signingUrl?: string | undefined;
    connectivePackageId?: string | undefined;
    files?: FileEntityDto[] | undefined;

    constructor(data?: IAppealSubmitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationDate = _data["communicationDate"] ? new Date(_data["communicationDate"].toString()) : <any>undefined;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : <any>undefined;
            this.appealDoc = _data["appealDoc"] ? DocumentDto.fromJS(_data["appealDoc"]) : <any>undefined;
            this.conformToReality = _data["conformToReality"];
            this.reportFileId = _data["reportFileId"];
            this.status = _data["status"];
            this.signingUrl = _data["signingUrl"];
            this.connectivePackageId = _data["connectivePackageId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppealSubmitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealSubmitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationDate"] = this.communicationDate ? this.communicationDate.toISOString() : <any>undefined;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : <any>undefined;
        data["appealDoc"] = this.appealDoc ? this.appealDoc.toJSON() : <any>undefined;
        data["conformToReality"] = this.conformToReality;
        data["reportFileId"] = this.reportFileId;
        data["status"] = this.status;
        data["signingUrl"] = this.signingUrl;
        data["connectivePackageId"] = this.connectivePackageId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }

    clone(): AppealSubmitDto {
        const json = this.toJSON();
        let result = new AppealSubmitDto();
        result.init(json);
        return result;
    }
}

export interface IAppealSubmitDto {
    id?: number;
    communicationDate?: Date;
    decisionDate?: Date;
    appealDoc?: DocumentDto | undefined;
    conformToReality?: boolean;
    reportFileId?: number;
    status?: AppealStatusCode;
    signingUrl?: string | undefined;
    connectivePackageId?: string | undefined;
    files?: FileEntityDto[] | undefined;
}

export class DocumentDto implements IDocumentDto {
    fileId?: number;
    fileName?: string | undefined;
    contentAsBase64?: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.contentAsBase64 = _data["contentAsBase64"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentAsBase64"] = this.contentAsBase64;
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    fileId?: number;
    fileName?: string | undefined;
    contentAsBase64?: string | undefined;
}

export enum AppealStatusCode {
    Draft = "Draft",
    SignedByWorker = "SignedByWorker",
    SignedByManager = "SignedByManager",
}

export class AppealCompanyDto implements IAppealCompanyDto {
    appealId?: number;
    name?: string | undefined;
    address?: AddressDto | undefined;
    onssCode?: string | undefined;
    sector?: ESectorTypes | undefined;

    constructor(data?: IAppealCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appealId = _data["appealId"];
            this.name = _data["name"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.onssCode = _data["onssCode"];
            this.sector = _data["sector"];
        }
    }

    static fromJS(data: any): AppealCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appealId"] = this.appealId;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["onssCode"] = this.onssCode;
        data["sector"] = this.sector;
        return data;
    }

    clone(): AppealCompanyDto {
        const json = this.toJSON();
        let result = new AppealCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IAppealCompanyDto {
    appealId?: number;
    name?: string | undefined;
    address?: AddressDto | undefined;
    onssCode?: string | undefined;
    sector?: ESectorTypes | undefined;
}

export enum ESectorTypes {
    PrivateSector = "PrivateSector",
    PublicSector = "PublicSector",
}

export class PaginatedResultsOfAppealGridDto implements IPaginatedResultsOfAppealGridDto {
    totalCount?: number;
    results?: AppealGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAppealGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AppealGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAppealGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAppealGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfAppealGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAppealGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAppealGridDto {
    totalCount?: number;
    results?: AppealGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class AppealGridDto implements IAppealGridDto {
    id?: number;
    sharepointId?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
    employerName?: string | undefined;
    employerOnssCode?: string | undefined;
    reason?: string | undefined;
    createdOn?: Date;
    status?: string | undefined;
    statusCode?: AppealStatusCode | undefined;
    sector?: ESectorTypes | undefined;
    region?: ERegion | undefined;
    statusId?: number;
    connectivePackageId?: string | undefined;
    isAdminAppeal?: boolean;

    constructor(data?: IAppealGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sharepointId = _data["sharepointId"];
            this.workerFirstName = _data["workerFirstName"];
            this.workerLastName = _data["workerLastName"];
            this.employerName = _data["employerName"];
            this.employerOnssCode = _data["employerOnssCode"];
            this.reason = _data["reason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.sector = _data["sector"];
            this.region = _data["region"];
            this.statusId = _data["statusId"];
            this.connectivePackageId = _data["connectivePackageId"];
            this.isAdminAppeal = _data["isAdminAppeal"];
        }
    }

    static fromJS(data: any): AppealGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sharepointId"] = this.sharepointId;
        data["workerFirstName"] = this.workerFirstName;
        data["workerLastName"] = this.workerLastName;
        data["employerName"] = this.employerName;
        data["employerOnssCode"] = this.employerOnssCode;
        data["reason"] = this.reason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["sector"] = this.sector;
        data["region"] = this.region;
        data["statusId"] = this.statusId;
        data["connectivePackageId"] = this.connectivePackageId;
        data["isAdminAppeal"] = this.isAdminAppeal;
        return data;
    }

    clone(): AppealGridDto {
        const json = this.toJSON();
        let result = new AppealGridDto();
        result.init(json);
        return result;
    }
}

export interface IAppealGridDto {
    id?: number;
    sharepointId?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
    employerName?: string | undefined;
    employerOnssCode?: string | undefined;
    reason?: string | undefined;
    createdOn?: Date;
    status?: string | undefined;
    statusCode?: AppealStatusCode | undefined;
    sector?: ESectorTypes | undefined;
    region?: ERegion | undefined;
    statusId?: number;
    connectivePackageId?: string | undefined;
    isAdminAppeal?: boolean;
}

export abstract class IAggregateResult implements IIAggregateResult {
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IIAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IAggregateResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IAggregateResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): IAggregateResult {
        throw new Error("The abstract class 'IAggregateResult' cannot be instantiated.");
    }
}

export interface IIAggregateResult {
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class AppealSubmitSaveResultDto implements IAppealSubmitSaveResultDto {
    appealId?: number;
    signingUrl?: string | undefined;

    constructor(data?: IAppealSubmitSaveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appealId = _data["appealId"];
            this.signingUrl = _data["signingUrl"];
        }
    }

    static fromJS(data: any): AppealSubmitSaveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppealSubmitSaveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appealId"] = this.appealId;
        data["signingUrl"] = this.signingUrl;
        return data;
    }

    clone(): AppealSubmitSaveResultDto {
        const json = this.toJSON();
        let result = new AppealSubmitSaveResultDto();
        result.init(json);
        return result;
    }
}

export interface IAppealSubmitSaveResultDto {
    appealId?: number;
    signingUrl?: string | undefined;
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item.toJSON());
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }

    clone(): FilterCriteriaInfo {
        const json = this.toJSON();
        let result = new FilterCriteriaInfo();
        result.init(json);
        return result;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export class SelectItem implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        return data;
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class ReferentialItemDto extends SelectItem implements IReferentialItemDto {
    keyValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyValue = _data["keyValue"];
        }
    }

    static fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        super.toJSON(data);
        return data;
    }

    clone(): ReferentialItemDto {
        const json = this.toJSON();
        let result = new ReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferentialItemDto extends ISelectItem {
    keyValue?: string | undefined;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    actions?: UserAction[] | undefined;
    role?: UserRoles;
    languageCode?: string | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.login = _data["login"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            this.role = _data["role"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["login"] = this.login;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        data["role"] = this.role;
        data["languageCode"] = this.languageCode;
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    actions?: UserAction[] | undefined;
    role?: UserRoles;
    languageCode?: string | undefined;
}

export enum UserAction {
    ViewData = "ViewData",
    EditData = "EditData",
    EditUser = "EditUser",
    EditMailTemplate = "EditMailTemplate",
    CreateAppeal = "CreateAppeal",
    EditEmployerAppeal = "EditEmployerAppeal",
}

export enum UserRoles {
    Admin = "Admin",
    Employee = "Employee",
    Manager = "Manager",
}

export class LoginDto implements ILoginDto {
    login?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.password = _data["password"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        data["token"] = this.token;
        return data;
    }

    clone(): LoginDto {
        const json = this.toJSON();
        let result = new LoginDto();
        result.init(json);
        return result;
    }
}

export interface ILoginDto {
    login?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
}

export class EditUserDto implements IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roleId?: number | undefined;
    languageId?: number | undefined;
    isActive?: boolean;
    newPassword?: string | undefined;
    fullName?: string | undefined;
    roleName?: UserRoles;

    constructor(data?: IEditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.languageId = _data["languageId"];
            this.isActive = _data["isActive"];
            this.newPassword = _data["newPassword"];
            this.fullName = _data["fullName"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): EditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["languageId"] = this.languageId;
        data["isActive"] = this.isActive;
        data["newPassword"] = this.newPassword;
        data["fullName"] = this.fullName;
        data["roleName"] = this.roleName;
        return data;
    }

    clone(): EditUserDto {
        const json = this.toJSON();
        let result = new EditUserDto();
        result.init(json);
        return result;
    }
}

export interface IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roleId?: number | undefined;
    languageId?: number | undefined;
    isActive?: boolean;
    newPassword?: string | undefined;
    fullName?: string | undefined;
    roleName?: UserRoles;
}

export class ConnectiveCallbackDto implements IConnectiveCallbackDto {
    packageId?: string | undefined;
    packageStatus?: string | undefined;

    constructor(data?: IConnectiveCallbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageStatus = _data["packageStatus"];
        }
    }

    static fromJS(data: any): ConnectiveCallbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectiveCallbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageStatus"] = this.packageStatus;
        return data;
    }

    clone(): ConnectiveCallbackDto {
        const json = this.toJSON();
        let result = new ConnectiveCallbackDto();
        result.init(json);
        return result;
    }
}

export interface IConnectiveCallbackDto {
    packageId?: string | undefined;
    packageStatus?: string | undefined;
}

export class ConnectiveResultDto implements IConnectiveResultDto {
    packageId?: string | undefined;
    signingUrl?: string | undefined;

    constructor(data?: IConnectiveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.signingUrl = _data["signingUrl"];
        }
    }

    static fromJS(data: any): ConnectiveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectiveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["signingUrl"] = this.signingUrl;
        return data;
    }

    clone(): ConnectiveResultDto {
        const json = this.toJSON();
        let result = new ConnectiveResultDto();
        result.init(json);
        return result;
    }
}

export interface IConnectiveResultDto {
    packageId?: string | undefined;
    signingUrl?: string | undefined;
}

export class DocumentRequestDto implements IDocumentRequestDto {
    signers?: StakeHolderDto[] | undefined;
    approvers?: StakeHolderDto[] | undefined;
    isSignersParallel?: boolean;
    isApproversParallel?: boolean;
    expiryDate?: Date | undefined;
    redirectUrl?: string | undefined;
    destinationId?: string | undefined;
    files?: ReportFileDto[] | undefined;
    initiator?: string | undefined;
    useMarker?: boolean;

    constructor(data?: IDocumentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["signers"])) {
                this.signers = [] as any;
                for (let item of _data["signers"])
                    this.signers!.push(StakeHolderDto.fromJS(item));
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(StakeHolderDto.fromJS(item));
            }
            this.isSignersParallel = _data["isSignersParallel"];
            this.isApproversParallel = _data["isApproversParallel"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.redirectUrl = _data["redirectUrl"];
            this.destinationId = _data["destinationId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ReportFileDto.fromJS(item));
            }
            this.initiator = _data["initiator"];
            this.useMarker = _data["useMarker"];
        }
    }

    static fromJS(data: any): DocumentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signers)) {
            data["signers"] = [];
            for (let item of this.signers)
                data["signers"].push(item.toJSON());
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["isSignersParallel"] = this.isSignersParallel;
        data["isApproversParallel"] = this.isApproversParallel;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["redirectUrl"] = this.redirectUrl;
        data["destinationId"] = this.destinationId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["initiator"] = this.initiator;
        data["useMarker"] = this.useMarker;
        return data;
    }

    clone(): DocumentRequestDto {
        const json = this.toJSON();
        let result = new DocumentRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentRequestDto {
    signers?: StakeHolderDto[] | undefined;
    approvers?: StakeHolderDto[] | undefined;
    isSignersParallel?: boolean;
    isApproversParallel?: boolean;
    expiryDate?: Date | undefined;
    redirectUrl?: string | undefined;
    destinationId?: string | undefined;
    files?: ReportFileDto[] | undefined;
    initiator?: string | undefined;
    useMarker?: boolean;
}

export class StakeHolderDto implements IStakeHolderDto {
    language?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    birthDate?: Date | undefined;
    phoneNumber?: string | undefined;
    order?: number;
    signingMethods?: string[] | undefined;

    constructor(data?: IStakeHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.order = _data["order"];
            if (Array.isArray(_data["signingMethods"])) {
                this.signingMethods = [] as any;
                for (let item of _data["signingMethods"])
                    this.signingMethods!.push(item);
            }
        }
    }

    static fromJS(data: any): StakeHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new StakeHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["order"] = this.order;
        if (Array.isArray(this.signingMethods)) {
            data["signingMethods"] = [];
            for (let item of this.signingMethods)
                data["signingMethods"].push(item);
        }
        return data;
    }

    clone(): StakeHolderDto {
        const json = this.toJSON();
        let result = new StakeHolderDto();
        result.init(json);
        return result;
    }
}

export interface IStakeHolderDto {
    language?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    birthDate?: Date | undefined;
    phoneNumber?: string | undefined;
    order?: number;
    signingMethods?: string[] | undefined;
}

export class ReportFileDto implements IReportFileDto {
    filePath?: string | undefined;
    fileRef?: string | undefined;
    fileLeafRef?: string | undefined;
    uniqueId?: string | undefined;
    contentVersion?: string | undefined;
    fileType?: string | undefined;
    connectiveDocumentId?: string | undefined;
    connectivePackageId?: string | undefined;

    constructor(data?: IReportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
            this.fileRef = _data["fileRef"];
            this.fileLeafRef = _data["fileLeafRef"];
            this.uniqueId = _data["uniqueId"];
            this.contentVersion = _data["contentVersion"];
            this.fileType = _data["fileType"];
            this.connectiveDocumentId = _data["connectiveDocumentId"];
            this.connectivePackageId = _data["connectivePackageId"];
        }
    }

    static fromJS(data: any): ReportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["fileRef"] = this.fileRef;
        data["fileLeafRef"] = this.fileLeafRef;
        data["uniqueId"] = this.uniqueId;
        data["contentVersion"] = this.contentVersion;
        data["fileType"] = this.fileType;
        data["connectiveDocumentId"] = this.connectiveDocumentId;
        data["connectivePackageId"] = this.connectivePackageId;
        return data;
    }

    clone(): ReportFileDto {
        const json = this.toJSON();
        let result = new ReportFileDto();
        result.init(json);
        return result;
    }
}

export interface IReportFileDto {
    filePath?: string | undefined;
    fileRef?: string | undefined;
    fileLeafRef?: string | undefined;
    uniqueId?: string | undefined;
    contentVersion?: string | undefined;
    fileType?: string | undefined;
    connectiveDocumentId?: string | undefined;
    connectivePackageId?: string | undefined;
}

export class LanguageDto implements ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
}

export class PaginatedResultsOfMailTemplateGridDto implements IPaginatedResultsOfMailTemplateGridDto {
    totalCount?: number;
    results?: MailTemplateGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMailTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MailTemplateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMailTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMailTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfMailTemplateGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfMailTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfMailTemplateGridDto {
    totalCount?: number;
    results?: MailTemplateGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class MailTemplateGridDto implements IMailTemplateGridDto {
    id?: number;
    subject?: string | undefined;
    language?: string | undefined;
    code?: string | undefined;

    constructor(data?: IMailTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.language = _data["language"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MailTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["language"] = this.language;
        data["code"] = this.code;
        return data;
    }

    clone(): MailTemplateGridDto {
        const json = this.toJSON();
        let result = new MailTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateGridDto {
    id?: number;
    subject?: string | undefined;
    language?: string | undefined;
    code?: string | undefined;
}

export class MailTemplateSearchDto extends PaginatedSearch implements IMailTemplateSearchDto {
    subject?: TextSearch | undefined;
    language?: TextSearch | undefined;
    code?: TextSearch | undefined;

    constructor(data?: IMailTemplateSearchDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] ? TextSearch.fromJS(_data["subject"]) : <any>undefined;
            this.language = _data["language"] ? TextSearch.fromJS(_data["language"]) : <any>undefined;
            this.code = _data["code"] ? TextSearch.fromJS(_data["code"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailTemplateSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): MailTemplateSearchDto {
        const json = this.toJSON();
        let result = new MailTemplateSearchDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateSearchDto extends IPaginatedSearch {
    subject?: TextSearch | undefined;
    language?: TextSearch | undefined;
    code?: TextSearch | undefined;
}

export class EditMailTemplateDto implements IEditMailTemplateDto {
    id?: number;
    subject?: string | undefined;
    content?: string | undefined;
    mailTemplateTypeId?: number;
    languageId?: number;

    constructor(data?: IEditMailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.mailTemplateTypeId = _data["mailTemplateTypeId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): EditMailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["mailTemplateTypeId"] = this.mailTemplateTypeId;
        data["languageId"] = this.languageId;
        return data;
    }

    clone(): EditMailTemplateDto {
        const json = this.toJSON();
        let result = new EditMailTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IEditMailTemplateDto {
    id?: number;
    subject?: string | undefined;
    content?: string | undefined;
    mailTemplateTypeId?: number;
    languageId?: number;
}

export class DisplayNameDto implements IDisplayNameDto {
    text?: string | undefined;

    constructor(data?: IDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }

    clone(): DisplayNameDto {
        const json = this.toJSON();
        let result = new DisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayNameDto {
    text?: string | undefined;
}

export class MailTemplateTypeGridDto implements IMailTemplateTypeGridDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IMailTemplateTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MailTemplateTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): MailTemplateTypeGridDto {
        const json = this.toJSON();
        let result = new MailTemplateTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateTypeGridDto {
    id?: number;
    name?: string | undefined;
}

export class EditMailTemplateTypeDto implements IEditMailTemplateTypeDto {
    id?: number;
    mailTypeTranslation?: DataTranslationDto | undefined;

    constructor(data?: IEditMailTemplateTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailTypeTranslation = _data["mailTypeTranslation"] ? DataTranslationDto.fromJS(_data["mailTypeTranslation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditMailTemplateTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMailTemplateTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailTypeTranslation"] = this.mailTypeTranslation ? this.mailTypeTranslation.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditMailTemplateTypeDto {
        const json = this.toJSON();
        let result = new EditMailTemplateTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditMailTemplateTypeDto {
    id?: number;
    mailTypeTranslation?: DataTranslationDto | undefined;
}

export class PostalCodeReferentialItemDto extends ReferentialItemDto implements IPostalCodeReferentialItemDto {

    constructor(data?: IPostalCodeReferentialItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PostalCodeReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostalCodeReferentialItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): PostalCodeReferentialItemDto {
        const json = this.toJSON();
        let result = new PostalCodeReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IPostalCodeReferentialItemDto extends IReferentialItemDto {
}

export class FunctionReferentialItemDto extends SelectItem implements IFunctionReferentialItemDto {
    description?: string | undefined;
    keyValue?: string | undefined;
    categoryId?: number;

    constructor(data?: IFunctionReferentialItemDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.keyValue = _data["keyValue"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): FunctionReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionReferentialItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["keyValue"] = this.keyValue;
        data["categoryId"] = this.categoryId;
        super.toJSON(data);
        return data;
    }

    clone(): FunctionReferentialItemDto {
        const json = this.toJSON();
        let result = new FunctionReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionReferentialItemDto extends ISelectItem {
    description?: string | undefined;
    keyValue?: string | undefined;
    categoryId?: number;
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    action?: UserAction;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    action?: UserAction;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class FrontendSettings implements IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureClientId = _data["azureClientId"];
            this.azureAuthority = _data["azureAuthority"];
            this.azureApiScope = _data["azureApiScope"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureClientId"] = this.azureClientId;
        data["azureAuthority"] = this.azureAuthority;
        data["azureApiScope"] = this.azureApiScope;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;
}

export class TranslationDto implements ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.translationCode = _data["translationCode"];
            this.text = _data["text"];
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.toTranslate = _data["toTranslate"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["translationCode"] = this.translationCode;
        data["text"] = this.text;
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["toTranslate"] = this.toTranslate;
        return data;
    }

    clone(): TranslationDto {
        const json = this.toJSON();
        let result = new TranslationDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;
}

export class SaveTranslationDto implements ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISaveTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationCode = _data["translationCode"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaveTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationCode"] = this.translationCode;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): SaveTranslationDto {
        const json = this.toJSON();
        let result = new SaveTranslationDto();
        result.init(json);
        return result;
    }
}

export interface ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class UpdateTranslationCommand implements IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;

    constructor(data?: IUpdateTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfTranslationDto implements IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TranslationSearch extends PaginatedSearch implements ITranslationSearch {
    languageCode?: string | undefined;
    text?: TextSearch | undefined;
    translationCode?: TextSearch | undefined;
    languageId?: ListSearchOfNullableLong | undefined;
    toTranslate?: BooleanSearch | undefined;

    constructor(data?: ITranslationSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.text = _data["text"] ? TextSearch.fromJS(_data["text"]) : <any>undefined;
            this.translationCode = _data["translationCode"] ? TextSearch.fromJS(_data["translationCode"]) : <any>undefined;
            this.languageId = _data["languageId"] ? ListSearchOfNullableLong.fromJS(_data["languageId"]) : <any>undefined;
            this.toTranslate = _data["toTranslate"] ? BooleanSearch.fromJS(_data["toTranslate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["translationCode"] = this.translationCode ? this.translationCode.toJSON() : <any>undefined;
        data["languageId"] = this.languageId ? this.languageId.toJSON() : <any>undefined;
        data["toTranslate"] = this.toTranslate ? this.toTranslate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TranslationSearch {
        const json = this.toJSON();
        let result = new TranslationSearch();
        result.init(json);
        return result;
    }
}

export interface ITranslationSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    text?: TextSearch | undefined;
    translationCode?: TextSearch | undefined;
    languageId?: ListSearchOfNullableLong | undefined;
    toTranslate?: BooleanSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableLong implements IFilterCriteriaBaseOfEListSearchTypeAndNullableLong {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableLong[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableLong.fromJS(item));
            }
            this.hasAValueDefined = _data["hasAValueDefined"];
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
            this.manualSearch = _data["manualSearch"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableLong {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableLong' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["hasAValueDefined"] = this.hasAValueDefined;
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        data["manualSearch"] = this.manualSearch;
        return data;
    }

    clone(): FilterCriteriaBaseOfEListSearchTypeAndNullableLong {
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableLong' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableLong {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableLong[] | undefined;
    hasAValueDefined?: boolean;
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
    manualSearch?: boolean;
}

export class ListSearchOfNullableLong extends FilterCriteriaBaseOfEListSearchTypeAndNullableLong implements IListSearchOfNullableLong {
    typeOfCriteria?: ECriteriaType;

    constructor(data?: IListSearchOfNullableLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeOfCriteria = _data["typeOfCriteria"];
        }
    }

    static fromJS(data: any): ListSearchOfNullableLong {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfCriteria"] = this.typeOfCriteria;
        super.toJSON(data);
        return data;
    }

    clone(): ListSearchOfNullableLong {
        const json = this.toJSON();
        let result = new ListSearchOfNullableLong();
        result.init(json);
        return result;
    }
}

export interface IListSearchOfNullableLong extends IFilterCriteriaBaseOfEListSearchTypeAndNullableLong {
    typeOfCriteria?: ECriteriaType;
}

export class CombinableCriteriaOfEListSearchTypeAndNullableLong implements ICombinableCriteriaOfEListSearchTypeAndNullableLong {
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableLong {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfEListSearchTypeAndNullableLong {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableLong();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableLong {
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
}

export class Result implements IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    rawValue?: MaybeOfObject;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResultError.fromJS(item));
            }
            this.isFailure = _data["isFailure"];
            this.isSuccess = _data["isSuccess"];
            this.rawValue = _data["rawValue"] ? MaybeOfObject.fromJS(_data["rawValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isFailure"] = this.isFailure;
        data["isSuccess"] = this.isSuccess;
        data["rawValue"] = this.rawValue ? this.rawValue.toJSON() : <any>undefined;
        return data;
    }

    clone(): Result {
        const json = this.toJSON();
        let result = new Result();
        result.init(json);
        return result;
    }
}

export interface IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    rawValue?: MaybeOfObject;
}

export enum ResultStatus {
    Success = "Success",
    Invalid = "Invalid",
    NotFound = "NotFound",
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfUserGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    id?: number;
    role?: string | undefined;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.login = _data["login"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["login"] = this.login;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UserGridDto {
        const json = this.toJSON();
        let result = new UserGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserGridDto {
    id?: number;
    role?: string | undefined;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
}

export class UserSearchDto extends PaginatedSearch implements IUserSearchDto {
    role?: TextSearch | undefined;
    login?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;

    constructor(data?: IUserSearchDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.role = _data["role"] ? TextSearch.fromJS(_data["role"]) : <any>undefined;
            this.login = _data["login"] ? TextSearch.fromJS(_data["login"]) : <any>undefined;
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["login"] = this.login ? this.login.toJSON() : <any>undefined;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): UserSearchDto {
        const json = this.toJSON();
        let result = new UserSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUserSearchDto extends IPaginatedSearch {
    role?: TextSearch | undefined;
    login?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: string | undefined;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"];
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: string | undefined;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    isCritical?: boolean;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isCritical = _data["isCritical"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isCritical"] = this.isCritical;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    isCritical?: boolean;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;

  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };